<template>
  <div id="app">
    <router-view
      v-wechat-title="$route.meta.title"
      v-if="isRouterAlive"
    ></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    // 获取当前可视区域的高度
    const height = document.documentElement.clientHeight;
    //alert("height=" + height);
    // 在页面整体加载完毕时
    window.onload = function() {
      // 把获取到的高度赋值给根div
      //alert("onload height=" + height);
      document.getElementById("app").style.height = `${height}px`;
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>

<style>
html,
body {
  padding: 0;
  margin: 0;
}

div {
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue